import { useState, useEffect } from 'react';
import { useParams, FaSearch, FaFileExcel, FaPlusCircle, DataTable, MdArrowDownward, FaPencilAlt, FaTrash, noDatapng, ToastContainer, BiCategory, TbNumbers, FaPlus, overlayStyle, loaderStyle, Select } from '../../common/common';
import useNavigation from '../../common/useNavigation';
import Sidebar from '../Components/Sidebar';
import Topbar from '../Components/Topbar';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { Modal } from "react-bootstrap";
import { useErrorContext } from '../../context/ErrorContext';
import { decodeHTML } from '../../common/CommonFunctions';
import MidPriceList from '../../middleware/Products/MidViewPriceList';
import axios from 'axios';

const ViewProductPriceList = () => {

    const { type } = useParams();
    const [issidebarOpen, setIssidebarOpen] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const handlesetIssidebarOpen = () => setIssidebarOpen(!issidebarOpen);
    const { values, setvalue, users, seacrh, setSearch, filteredPriceList, handleShowModal, handleCloseModal, handleSubmit, handleChange, handleFileChange, showEditcategoryModal, handleShowEditModal, handleCloseEditModal, deleteImage, handleEditSubmit, priceListType, filteredData, showEditPriceListModal, countryData, stateData, productVariants, products, handleGetState, handleGetCities, distributors, handleSelectChange, handleProductPriceListSubmit, deletePriceList } = MidPriceList(type);

    const { navigateAddCategory, navigateAddProductPriceList } = useNavigation();

    if (Array.isArray(users) && users.length > 0) {
        var AppID = users[0]['AppID'];
        var ProfilePic = users[0]['ProfilePic'];
        var usertype = users[0]['UserType'];
        var username = users[0]['FullName'];
        var ActiveUser = users[0]["Status"]
    }

    const columns = {
        state: [
            {
                name: 'Image',
                cell: row => (
                    <img
                        src={`${process.env.REACT_APP_API_URL}/api/products/uploads/${row.product_variant_image}`}
                        alt="Product Variant"
                        className="w-12 h-12 md:w-16 md:h-16 object-cover rounded"
                    />
                ),
                sortable: true
            },
            {
                name: 'Product Variant',
                selector: row => row.product_variant,
                sortable: true
            },
            {
                name: 'State',
                selector: row => row.state_id,
                sortable: true,
                cell: row => (
                    <span>{row.state_name || `State ID: ${row.state_id}`}</span>
                )
            },
            {
                name: 'Price',
                selector: row => row.price,
                sortable: true
            },
            {
                name: 'Created At',
                selector: row => new Date(row.created_at).toLocaleDateString(),
                sortable: true
            },
            {
                name: 'Updated At',
                selector: row => new Date(row.updated_at).toLocaleDateString(),
                sortable: true
            },
            {
                name: 'Actions',
                cell: row => (
                    <div className='flex space-x-2'>
                        {ActiveUser === 1 &&
                            <Button
                                variant="primary"
                                className="btn btn-primary text-sm p-1 h-10 !bg-[#cbd7fa] !text-black !border-[#b9ccff] rounded-full w-10"
                                onClick={() => handleShowEditModal(row.id, priceListType)}

                            >
                                <FaPencilAlt className='text-[#193b99] m-auto' />
                            </Button>
                        }

                        {ActiveUser === 1 &&
                            <Button
                                variant="danger"
                                className="btn btn-primary text-sm p-1 h-10 !bg-[#ffd7d7] !text-white !border-[#ffd7d7] rounded-full w-10"
                                onClick={() => deletePriceList(row.id, priceListType)}
                            >
                                <FaTrash className='text-red-700 m-auto' />
                            </Button>
                        }
                    </div>
                )
            }
        ],
        distributor: [
            {
                name: 'Image',
                cell: row => (
                    <img
                        src={`${process.env.REACT_APP_API_URL}/api/products/uploads/${row.product_variant_image}`}
                        alt="Product Variant"
                        className="w-12 h-12 md:w-16 md:h-16 object-cover rounded"
                    />
                ),
                sortable: true
            },
            {
                name: 'Product Variant',
                selector: row => row.product_variant,
                sortable: true
            },
            {
                name: 'Distributor',
                selector: row => row.full_name,
                sortable: true,
                cell: row => (
                    <span>{row.full_name || 'N/A'}</span>
                )
            },
            {
                name: 'Price',
                selector: row => row.price,
                sortable: true
            },
            {
                name: 'Created At',
                selector: row => new Date(row.created_at).toLocaleDateString(),
                sortable: true
            },
            {
                name: 'Updated At',
                selector: row => new Date(row.updated_at).toLocaleDateString(),
                sortable: true
            },
            {
                name: 'Actions',
                cell: row => (
                    <div className='flex space-x-2'>
                        {ActiveUser === 1 &&
                            <Button
                                variant="primary"
                                className="btn btn-primary text-sm p-1 h-10 !bg-[#cbd7fa] !text-black !border-[#b9ccff] rounded-full w-10"
                                onClick={() => handleShowEditModal(row.id, priceListType)}
                            >
                                <FaPencilAlt className='text-[#193b99] m-auto' />
                            </Button>
                        }

                        {ActiveUser === 1 &&
                            <Button
                                variant="danger"
                                className="btn btn-primary text-sm p-1 h-10 !bg-[#ffd7d7] !text-white !border-[#ffd7d7] rounded-full w-10"
                                onClick={() => deletePriceList(row.id, priceListType)}
                            >
                                <FaTrash className='text-red-700 m-auto' />
                            </Button>
                        }
                    </div>
                )
            }
        ]
    };


    return (
        <div className='md:flex md:flex-row md:w-full'>
            <div className={`${issidebarOpen ? 'w-0  md:w-1/5' : 'w-0'}`}>
                <Sidebar handleSideBar={handlesetIssidebarOpen} issidebarOpen={issidebarOpen} UserTypeData={usertype} userName={username} appID={AppID} profilePic={ProfilePic} currentUserType={type} ActiveUser={ActiveUser} />
            </div>
            <div className={`${issidebarOpen ? 'w-full  md:w-[80%]' : 'ml-20 w-full'} `} >
                <Topbar issidebarOpen={issidebarOpen} UserTypeData={usertype} currentUserType={type} />
                <div className="lg:w-full lg:flex lg:flex-col lg:justify-between relative ">
                    <div className="w-full">
                        <div className=" p-2 mx-3 text-[#1e3a8a]">
                            <div className='px-3'>
                                <h1 className=' text-lg text-theme-color-text font-bold'> Custom Pricelist </h1>
                                <p className=' text-gray-600 text-[16px] '>A product category is a group of similar type of products. Ex. Menswear,Womenswear,Childrenswear</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-start-1 col-end-13">
                        <div className=" flex-row rounded-xl m-3 p-3 bg-white shadow-xs border-[1px] border-solid border-[#e5e5e5]">
                            <div className=' relative flex flex-col min-w-0 break-words'>
                                <div className='p-2'>
                                    <div className='flex flex-col lg:flex-row justify-between items-center '>
                                        <div className='flex flex-row'>
                                            <h5 className=" capitalize text-xl font-bold p-2">View Custom Pricelist</h5>
                                        </div>

                                        <div className='flex flex-row space-x-2'>
                                            <div className="relative bg-gray-100 rounded-md border-[1px] border-solid border-gray-200 mx-2">
                                                <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                                                <input
                                                    id="searchbox"
                                                    type="text"
                                                    name="searchbox"
                                                    placeholder="Search"
                                                    className="bg-transparent pl-12 pr-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-blue-400 rounded-md"
                                                    value={seacrh}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                    aria-label="Search"
                                                />
                                            </div>

                                            {ActiveUser === 1 &&
                                                <div className="hidden md:flex md:flex-row gap-2 ">
                                                    <Button variant="primary" className="md:!d-flex align-items-center hidden" onClick={navigateAddProductPriceList}>
                                                        <FaPlusCircle className="mr-2" />
                                                        Add PriceList
                                                    </Button>
                                                </div>
                                            }

                                            <DropdownButton
                                                as={ButtonGroup}
                                                title="Action"
                                                id="bg-vertical-dropdown-3"
                                                className="block lg:!hidden"
                                            >
                                                <Dropdown.Item eventKey="2" onClick={navigateAddCategory}>Add PriceList</Dropdown.Item>
                                            </DropdownButton>
                                        </div>
                                    </div>

                                    {/* Price List Type Selector */}
                                    <div className="flex items-center mb-4">
                                        <label className="mr-4">
                                            <input
                                                type="radio"
                                                className="mr-2"
                                                checked={priceListType === 'state'}
                                                onChange={() => handleChange('state')}
                                            />
                                            State-wise Price List
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                className="mr-2"
                                                checked={priceListType === 'distributor'}
                                                onChange={() => handleChange('distributor')}
                                            />
                                            Distributor-wise Price List
                                        </label>
                                    </div>

                                    {isLoading ? (
                                        <div style={overlayStyle}>
                                            <div style={loaderStyle}>Loading...</div>
                                        </div>
                                    ) : filteredData.length > 0 ? (
                                        <DataTable
                                            columns={columns[priceListType]}
                                            data={filteredData}
                                            pagination
                                            sortIcon={<MdArrowDownward />}
                                        />
                                    ) : (
                                        <center>
                                            <img src={noDatapng} height={300} width={300} alt="No Data Exist" />
                                            <h1 className='text-lg -translate-y-10 text-gray-300 font-bold'> No Data Exist! </h1>
                                        </center>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Edit Modal (keep your existing modal code) */}
                    <Modal size="lg" show={showEditPriceListModal} onHide={handleCloseEditModal} aria-labelledby="example-modal-sizes-title-lg">
                        <Modal.Body>
                            <div className="relative border-b border-slate-200/60 py-2">
                                <label className="text-lg">Edit PriceList</label>
                                <div className="h-6 text-xs bg-slate-200 text-slate-500 px-2 flex items-center rounded-md absolute inset-y-0 right-0 my-auto mr-4 cursor-pointer"
                                    onClick={handleCloseEditModal}>ESC / Close</div>
                            </div>
                            <div className='p-2'>
                                <div>
                                    {/* State Section */}
                                    {values?.priceListType === 'state' && (
                                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                            <div>
                                                <label className="block my-3">
                                                    <span className="block text-sm font-medium text-slate-700">State</span>
                                                </label>
                                                <div className="flex relative border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md">
                                                    <TbNumbers className='text-gray-400' />
                                                    <input
                                                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 cursor-not-allowed text-gray-400"
                                                        type="text"
                                                        placeholder="State"
                                                        value={values.state?.label || ''}
                                                        disabled={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Distributor Section */}
                                    {values.priceListType === 'distributor' && (
                                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                            <div>
                                                <label className="block my-3">
                                                    <span className="block text-sm font-medium text-slate-700">Distributor</span>
                                                </label>
                                                <div className="flex relative border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md">
                                                    <TbNumbers className='text-gray-400' />
                                                    <input
                                                        className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 cursor-not-allowed text-gray-400"
                                                        type="text"
                                                        placeholder="Distributor"
                                                        value={values.distributorName || `Distributor ${values.distributorName || ''}`}
                                                        disabled={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="mt-6">
                                        <h4 className="text-lg font-semibold mb-4">Product Variant Prices</h4>
                                        <div className="space-y-4">
                                            <div className="grid grid-cols-1 lg:grid-cols-3 gap-3 items-end">
                                                {/* Product Field */}
                                                <div>
                                                    <label className="block my-3">
                                                        <span className="block text-sm font-medium text-slate-700">Product</span>
                                                    </label>
                                                    <div className="flex relative border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md">
                                                        <TbNumbers className='text-gray-400' />
                                                        <input
                                                            className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 cursor-not-allowed text-gray-400"
                                                            type="text"
                                                            placeholder="Product Name"
                                                            value={values.product || ''}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Variant Field */}
                                                <div>
                                                    <label className="block my-3">
                                                        <span className="block text-sm font-medium text-slate-700">Product Variant</span>
                                                    </label>
                                                    <div className="flex relative border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md">
                                                        <TbNumbers className='text-gray-400' />
                                                        <input
                                                            className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 cursor-not-allowed text-gray-400"
                                                            type="text"
                                                            placeholder="Variant"
                                                            value={values.variant || ''}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                </div>

                                                {/* Price Field (editable) */}
                                                <div>
                                                    <label className="block my-3">
                                                        <span className="block text-sm font-medium text-slate-700">Price</span>
                                                    </label>
                                                    <div className="flex relative border-[1px] border-solid border-[#c5c5c5] p-2 w-full rounded-md">
                                                        <TbNumbers className='text-gray-400' />
                                                        <input
                                                            className="bg-transparent ml-2 pl-2 focus:outline-none w-full pr-6 "
                                                            type="number"
                                                            placeholder="Enter Price"
                                                            value={values.price || ''}
                                                            onChange={(e) => setvalue(prev => ({ ...prev, price: e.target.value }))}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flex justify-end'>
                                        {/* <Button type="button" className="bg-[#0d6efd] mx-2 btn btn-sm text-white flex justify-end" onClick={handleProductDetailsSubmit}> Submit</Button> */}
                                        <Button type="button" className="bg-[#0d6efd] mx-2 btn btn-sm text-white flex justify-end" onClick={handleProductPriceListSubmit}> Update PriceList </Button>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>

                    <ToastContainer />
                </div>
            </div>
        </div>
    )
}

export default ViewProductPriceList;